import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6521d5ba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6521d5ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6521d5ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6521d5ba')) {
      api.createRecord('6521d5ba', component.options)
    } else {
      api.reload('6521d5ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6521d5ba&scoped=true", function () {
      api.rerender('6521d5ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/dashboard/views/index.vue"
export default component.exports